export default {
    error404: 'Oops, mauvais détour!',
    cantValidateUnsubscribe:
        "Impossible de faire le désabonnment pour l'instant. Veuillez réessayer plus tard.",
    unsubscribeTitle: 'Désabonnement complété',
    unsubscribeText: 'Vous ne recevrez plus de communication par courriel de la part de {dealer}.',
};
